export const BaseSort = {
    DEFAULT: "DEFAULT",
} as const;
export const ProductSortBy = {
    ...BaseSort,
    PRICE_ASC: "PRICE_ASC",
    PRICE_DESC: "PRICE_DESC",
} as const;
export type ProductSortByEnum = keyof typeof ProductSortBy;
export type AnySortBy = ProductSortByEnum;
